import Header from './components/Header';
import Hero from './components/Hero';
import SectionIndex from './components/SectionIndex';
import SectionMedia from './components/SectionMedia';
import SectionCards from './components/SectionCards';
import SectionApp from './components/SectionApp';
import SectionCarousel from './components/SectionCarousel';
import SectionAbout from './components/SectionAbout';
import SectionFeatures from './components/SectionFeatures';
import SectionUpdates from './components/SectionUpdates';
import SectionFaq from './components/SectionFaq';
import SectionContact from './components/SectionContact';
import SectionComments from './components/SectionComments';
import SectionTopics from './components/SectionTopics';
import SectionRanking from './components/SectionRanking';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionIndex />
        <SectionMedia />
        <SectionCards />
        <SectionApp />
        <SectionCarousel />
        <SectionAbout />
        <SectionFeatures />
        <SectionUpdates />
        <SectionFaq />
        <SectionContact />
        <SectionComments />
        <SectionTopics />
        <SectionRanking />
      </main>
      <Footer />
    </>
  );
}